import { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import GoogleReviewSnippet from "../components/GoogleReviewSnippet";
import Breadcrumbs from "../components/Breadcrumbs";
import TipsTricks from "../components/TipsTricks";
import FAQSection from "../components/FAQSection";
import { MdLocationOn } from "react-icons/md";


import SOLARPLANT from "../images/videos/SOLARPLANT.mp4";
import INDUSTRIALMANU from '../images/INDUSTRIALMANU.jpg'
import COMMERCIALESTAB from '../images/COMMERCIALESTAB.jpg'
import EDUCATIONINSTI from '../images/EDUCATIONINSTI.jpg'
import INDIANRESIDENTIAL from '../images/INDIANRESIDENTIAL.jpg'
import INDUSTRIALREALESTATE from '../images/INDUSTRIALREALESTATE.jpg'
import GOVMENRPROJECTS from '../images/GOVMENRPROJECTS.jpg'


import { FaIndustry, FaBuilding, FaSchool, FaHome, FaCity, FaLandmark } from "react-icons/fa";
import "../pages/Home.css";
import HomeBanner from "./HomeBanner";
import HOMEABIMG from "../images/HOMEABIMG.jpg";
import { FaLeaf, FaBullseye, FaGlobeAsia } from "react-icons/fa";
import { FaCogs, FaUsers, FaLightbulb, FaHandshake } from "react-icons/fa";
import {
  FaSolarPanel,
  FaTools,
  FaWater,
  FaFlask,
  FaRecycle,
  FaBolt,
  FaTrash
} from "react-icons/fa";

import {
  MdPublic,
} from "react-icons/md";

// import Count from "../components/Count";

import SOLARPLANTATION from '../images/SOLARPLANTATION.jpg'
import SOLARMAINTENENCandSERVICE from '../images/SOLARMAINTENENCandSERVICE.jpg'
import STP from '../images/STP.jpg'
import ETP from '../images/ETP.jpg'
import BIOGAS from '../images/BIOGAS.jpg'
import EA from '../images/EA.jpg'
import GA from '../images/GA.jpg'
import SWA from '../images/SWA.jpg'

export default function Home() {

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  const [preview, setPreview] = useState(null);
  return (
    <>


      <Navbar />

      <Helmet>
        <title>Best Solar Company in Madurai | Top Rated Solar, ETP, STP, Energy Audit Services</title>
        <meta name="description" content="Looking for the best solar company in Madurai? We provide top-rated solar panel installation, ETP, STP, energy audit, green audit, and solid waste management services for residential & commercial buildings. Reduce EB bills today." />
        <meta name="keywords" content="solar company in Madurai, best solar installation Madurai, rooftop solar Madurai, reduce EB bill, ETP plant Madurai, STP system Madurai, energy audit Madurai, green audit Madurai, solid waste management Madurai, commercial solar Madurai, residential solar Madurai" />
        
        {/* Schema.org for Google Snippets */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "LocalBusiness",
              "name": "RAD EnviroNex",
              "image": "https://radenvironex.com/logo.png",
              "telephone": "+91-95978-39564",
              "url": "https://radenvironex.com",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Madurai",
                "addressLocality": "Madurai",
                "addressRegion": "Tamil Nadu",
                "addressCountry": "IN"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 9.9252,
                "longitude": 78.1198
              },
              "openingHoursSpecification": {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": [
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday"
                ],
                "opens": "09:00",
                "closes": "19:00"
              },
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.8",
                "reviewCount": "120"
              },
              "hasOfferCatalog": {
                "@type": "OfferCatalog",
                "name": "Environmental Engineering Services",
                "itemListElement": [
                  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Solar Installation" } },
                  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "STP - Sewage Treatment Plant" } },
                  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "ETP - Effluent Treatment Plant" } },
                  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Biogas Systems" } },
                  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Energy Audit" } },
                  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Green Audit" } },
                  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Environmental Audit" } }
                ]
              }
            }
          `}
        </script>

        {/* Breadcrumb Schema */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Home",
                  "item": "https://radenvironex.com"
                }
              ]
            }
          `}
        </script>


        {/* FAQ Schema */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "mainEntity": [
                {
                  "@type": "Question",
                  "name": "Why choose RAD EnviroNex for Solar in Madurai?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We are #1 in Madurai for Solar & Waste Water Treatment, providing customized solar solutions that maximize energy generation while reducing costs."
                  }
                },
                {
                  "@type": "Question",
                  "name": "What industries do you serve with STP/ETP solutions?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We serve a wide range of industries globally, including manufacturing units, commercial establishments, hospitals, and educational institutions."
                  }
                },
                {
                  "@type": "Question",
                  "name": "How long does a typical solar installation take?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "A standard rooftop solar installation for homes or small businesses typically takes 3-7 days after site assessment and design approval."
                  }
                }
              ]
            }
          `}
        </script>
      </Helmet>


      {/* Hidden H1 for SEO */}
      <h1 style={{ display: 'none' }}>Best Solar Company in Madurai | Solar Panel Installation</h1>

      {/* HERO */}

      <HomeBanner />
      <GoogleReviewSnippet />


      {/* ABOUT SECTION */}
      <section id="home-ab" className="home-about">
        <div className="container">
          <div className="row align-items-center">

            {/* IMAGE */}
            <div
              className="col-lg-6 col-md-12 mb-4 mb-lg-0"
              data-aos="fade-right"
            >
              <div className="about-image">
                <img src={HOMEABIMG} alt="About RAD EnviroNex" />
              </div>
            </div>

            {/* CONTENT */}
            <div
              className="col-lg-6 col-md-12"
              data-aos="fade-up"
            >
              <div className="about-content">
                <h2>About RAD EnviroNex</h2>

                <p>
                  RAD EnviroNex is a forward-thinking environmental solutions
                  company dedicated to building a cleaner, smarter, and more
                  sustainable future.
                </p>

                <p>
                  We specialize in innovative approaches that bridge
                  environmental responsibility with practical, results-driven
                  solutions for today’s challenges.
                </p>

                <p>
                  At RAD EnviroNex, we believe environmental progress and
                  economic growth can go hand in hand. Our mission is to deliver
                  reliable, efficient, and environmentally responsible
                  solutions that help organizations reduce impact, optimize
                  resources, and move confidently toward a greener tomorrow.
                </p>

                <p className="highlight">
                  Our vision is to be a catalyst for positive environmental
                  change—empowering communities, businesses, and industries to
                  thrive while protecting the planet for future generations.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>




      <section id="MVV" className="mvv-section">
        <div className="container">
          <div className="row text-center mb-5">
            <div className="col-12" data-aos="fade-up">
              <h2 className="mvv-heading">Mission, Vision & Values</h2>
              <p className="mvv-sub">
                Guiding principles that shape RAD EnviroNex
              </p>
            </div>
          </div>

          <div className="row g-4">

            {/* MISSION */}
            <div className="col-lg-4 col-md-6" data-aos="fade-right">
              <div className="mvv-card">
                <div className="mvv-icon">
                  <FaBullseye />
                </div>
                <h4>Our Mission</h4>
                <p>
                  To deliver innovative, reliable, and sustainable environmental and
                  renewable energy solutions that reduce carbon emissions, optimize
                  resource efficiency, and support long-term environmental growth.
                </p>
              </div>
            </div>

            {/* VISION */}
            <div className="col-lg-4 col-md-6" data-aos="fade-right" data-aos-delay="150">
              <div className="mvv-card">
                <div className="mvv-icon">
                  <FaGlobeAsia />
                </div>
                <h4>Our Vision</h4>
                <p>
                  To be a leading force in renewable energy and environmental
                  management, driving the transition toward a Net Zero Carbon future
                  by 2070 through clean energy adoption and responsible innovation.
                </p>
              </div>
            </div>

            {/* VALUES */}
            <div className="col-lg-4 col-md-12" data-aos="fade-right" data-aos-delay="300">
              <div className="mvv-card">
                <div className="mvv-icon">
                  <FaLeaf />
                </div>
                <h4>Our Values</h4>
                <p>
                  Sustainability first, integrity in every action, and transparency
                  in communication. We believe responsible business creates lasting
                  value for communities, industries, and the planet.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>




      <section id="TE" className="te-section">
        <div className="container">
          <div className="row text-center mb-5">
            <div className="col-12" data-aos="fade-up">
              <h2 className="te-heading">Technical Excellence</h2>
              <p className="te-sub">
                How we deliver consistent quality, innovation, and long-term value
              </p>
            </div>
          </div>

          <div className="row g-4">

            <div className="col-lg-6" data-aos="slide-up">
              <div className="te-card">
                <div className="te-icon"><FaCogs /></div>
                <h4>High-Quality Engineering</h4>
                <p>
                  We are committed to precision engineering, continuous improvement,
                  and strict adherence to industry best practices to ensure reliable
                  and durable solutions.
                </p>
              </div>
            </div>

            <div className="col-lg-6" data-aos="slide-up" data-aos-delay="150">
              <div className="te-card">
                <div className="te-icon"><FaUsers /></div>
                <h4>Customer-Centric Approach</h4>
                <p>
                  We listen, understand, and deliver customized solutions that align
                  with client needs and create real, measurable value.
                </p>
              </div>
            </div>

            <div className="col-lg-6" data-aos="slide-up" data-aos-delay="300">
              <div className="te-card">
                <div className="te-icon"><FaLightbulb /></div>
                <h4>Innovation for Impact</h4>
                <p>
                  We embrace innovation to develop practical, future-ready solutions
                  that drive meaningful environmental and operational impact.
                </p>
              </div>
            </div>

            <div className="col-lg-6" data-aos="slide-up" data-aos-delay="450">
              <div className="te-card">
                <div className="te-icon"><FaHandshake /></div>
                <h4>Long-Term Partnership</h4>
                <p>
                  We build lasting relationships based on trust, performance, and
                  shared sustainability goals, supporting clients beyond delivery.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      <Breadcrumbs />


      <section id="services" className="services-section">
        <div className="container">

          <div className="row text-center mb-5">
            <div className="col-12" data-aos="fade-up">
              <h2 className="services-heading">Our Services</h2>
              <p className="services-sub">
                Sustainable solutions across energy and environmental management
              </p>
            </div>
          </div>

          {/* 1. SOLAR PLANTATION */}
          <div className="row align-items-center service-row">
            <div className="col-lg-6" data-aos="fade-up">
              <div className="service-content">
                <h3><FaSolarPanel /> Solar Installation</h3>
                <p>
                  We provide end-to-end solar Installation solutions, from site assessment
                  and system design to installation and commissioning. Our solar
                  projects maximize energy generation and reduce carbon emissions.
                </p>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-left">
              <img src={SOLARPLANTATION} className="service-img" onClick={() => setPreview(SOLARPLANTATION)} alt="Solar Panel Installation in Madurai" />
            </div>

          </div>

          {/* 2. SOLAR MAINTENANCE */}
          <div className="row align-items-center service-row reverse">
            <div className="col-lg-6" data-aos="fade-right">
              <img src={SOLARMAINTENENCandSERVICE} className="service-img" onClick={() => setPreview(SOLARMAINTENENCandSERVICE)} alt="Solar Services & Maintenance" />
            </div>

            <div className="col-lg-6" data-aos="fade-up">
              <div className="service-content">
                <h3><FaTools /> Solar Services & Maintenance</h3>
                <p>
                  Comprehensive monitoring, preventive maintenance, troubleshooting,
                  and upgrades to ensure optimal solar system performance.
                </p>
              </div>
            </div>
          </div>

          {/* 3. STP */}
          <div className="row align-items-center service-row">
            <div className="col-lg-6" data-aos="fade-up">
              <div className="service-content">
                <h3><FaWater /> STP – Sewage Treatment Plant</h3>
                <p>
                  Efficient sewage treatment systems ensuring regulatory compliance,
                  water reuse, and sustainable wastewater management.
                </p>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-left">
              <img src={STP} className="service-img" onClick={() => setPreview(STP)} alt="STP – Sewage Treatment Plant" />
            </div>

          </div>

          {/* 4. ETP */}
          <div className="row align-items-center service-row reverse">
            <div className="col-lg-6" data-aos="fade-right">
              <img src={ETP} className="service-img" onClick={() => setPreview(ETP)} alt="ETP Plant Setup Madurai" />
            </div>

            <div className="col-lg-6" data-aos="fade-up">
              <div className="service-content">
                <h3><FaFlask /> ETP – Effluent Treatment Plant</h3>
                <p>
                  Industrial wastewater treatment solutions focused on pollution
                  reduction, compliance, and resource recovery.
                </p>
              </div>
            </div>
          </div>

          {/* 5. BIOGAS */}
          <div className="row align-items-center service-row">
            <div className="col-lg-6" data-aos="fade-up">
              <div className="service-content">
                <h3><FaRecycle /> Biogas Systems</h3>
                <p>
                  Customized biogas plants converting organic waste into renewable
                  energy, reducing waste disposal challenges and promoting circular
                  economy practices.
                </p>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-left">
              <img src={BIOGAS} className="service-img" onClick={() => setPreview(BIOGAS)} alt="Biogas Systems Service" />
            </div>

          </div>

          {/* 6. ENERGY AUDIT */}
          <div className="row align-items-center service-row reverse">
            <div className="col-lg-6" data-aos="fade-right">
              <img src={EA} className="service-img" onClick={() => setPreview(EA)} alt="Energy Audit Service" />
            </div>

            <div className="col-lg-6" data-aos="fade-up">
              <div className="service-content">
                <h3><FaBolt /> Energy Audit</h3>
                <p>
                  Detailed energy consumption analysis identifying inefficiencies,
                  cost-saving opportunities, and performance improvements.
                </p>
              </div>
            </div>
          </div>

          {/* 7. GREEN AUDIT */}
          <div className="row align-items-center service-row">
            <div className="col-lg-6" data-aos="fade-up">
              <div className="service-content">
                <h3><FaLeaf /> Green Audit</h3>
                <p>
                  Comprehensive environmental audits focusing on sustainability,
                  resource conservation, waste management, and compliance.
                </p>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-left">
              <img src={GA} className="service-img" onClick={() => setPreview(GA)} alt="Green Audit Service" />
            </div>

          </div>

          {/* 8. SOLID WASTE */}
          <div className="row align-items-center service-row reverse">
            <div className="col-lg-6" data-aos="fade-right">
              <img src={SWA} className="service-img" onClick={() => setPreview(SWA)} alt="Environmental Audit Service" />
            </div>

            <div className="col-lg-6" data-aos="fade-up">
              <div className="service-content">
                <h3><FaTrash /> Environmental Audit</h3>
                <p>
                  Integrated waste management solutions including segregation,
                  recycling, composting, and responsible disposal.
                </p>
              </div>
            </div>
          </div>

        </div>

        {preview && (
          <div className="img-modal" onClick={() => setPreview(null)}>
            <img src={preview} alt="Preview" />
          </div>
        )}
      </section>

      <TipsTricks />







      <section id="TARGCUST" className="targcust-section">
        <div className="container">

          {/* HEADING */}
          <div className="row text-center mb-5">
            <div className="col-12" data-aos="fade-up">
              <h2 className="targcust-heading">Our Targeted Customers</h2>
              <p className="targcust-sub">
                Empowering diverse sectors with sustainable energy and environmental solutions
              </p>
            </div>
          </div>

          <div className="row g-4">

            {/* 1. INDUSTRIAL */}
            <div className="col-lg-4 col-md-6" data-aos="fade-up">
              <div className="targcust-card">
                <img src={INDUSTRIALMANU} alt="Solar for Industrial & Manufacturing Units in Madurai" />
                <div className="targcust-content">
                  <h4><FaIndustry /> Industrial & Manufacturing Units</h4>
                  <p>
                    Industries implementing solar power, ETP/STP systems, waste
                    management, and energy audits to improve efficiency and ensure
                    regulatory compliance.
                  </p>
                </div>
              </div>
            </div>

            {/* 2. COMMERCIAL */}
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
              <div className="targcust-card">
                <img src={COMMERCIALESTAB} alt="Commercial Establishments" />
                <div className="targcust-content">
                  <h4><FaBuilding /> Commercial Establishments</h4>
                  <p>
                    Offices, malls, hotels, hospitals, and IT parks adopting clean
                    energy, waste management, and green audit solutions.
                  </p>
                </div>
              </div>
            </div>

            {/* 3. EDUCATION */}
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
              <div className="targcust-card">
                <img src={EDUCATIONINSTI} alt="Educational Institutions" />
                <div className="targcust-content">
                  <h4><FaSchool /> Educational Institutions</h4>
                  <p>
                    Schools, colleges, and universities implementing solar, STP,
                    biogas plants, and green campus initiatives.
                  </p>
                </div>
              </div>
            </div>

            {/* 4. RESIDENTIAL */}
            <div className="col-lg-4 col-md-6" data-aos="fade-up">
              <div className="targcust-card">
                <img src={INDIANRESIDENTIAL} alt="Residential & Housing Societies" />
                <div className="targcust-content">
                  <h4><FaHome /> Residential & Housing Societies</h4>
                  <p>
                    Apartments and gated communities adopting rooftop solar, STP,
                    waste management, and biogas solutions.
                  </p>
                </div>
              </div>
            </div>

            {/* 5. REAL ESTATE */}
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
              <div className="targcust-card">
                <img src={INDUSTRIALREALESTATE} alt="Infrastructure & Real Estate" />
                <div className="targcust-content">
                  <h4><FaCity /> Infrastructure & Real Estate Developers</h4>
                  <p>
                    Builders integrating renewable energy, wastewater treatment, and
                    green compliance in modern developments.
                  </p>
                </div>
              </div>
            </div>

            {/* 6. GOVERNMENT */}
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
              <div className="targcust-card">
                <img src={GOVMENRPROJECTS} alt="Government Projects" />
                <div className="targcust-content">
                  <h4><FaLandmark /> Government & Public Sector</h4>
                  <p>
                    Municipal bodies and government institutions implementing
                    renewable energy and environmental management projects.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>





      <section id="netzero" className="netzero-section">
        <div className="container">

          {/* HEADING */}
          <div className="row text-center mb-5">
            <div className="col-12" data-aos="fade-up">
              <h2 className="netzero-heading">Net Zero Carbon Commitment</h2>
              <p className="netzero-sub">
                India and Tamil Nadu aligned toward a sustainable future
              </p>
            </div>
          </div>

          <div className="row g-4">

            {/* INDIA */}
            <div className="col-lg-6 col-md-12" data-aos="slide-up">
              <div className="netzero-card">
                <div className="netzero-icon">
                  <MdPublic />
                </div>

                <h3>India’s Net Zero Commitment</h3>

                <p>
                  At the COP26 climate summit held in Glasgow in November 2021,
                  Prime Minister Narendra Modi announced that India will achieve
                  net zero carbon emissions by 2070.
                </p>

                <p>
                  This declaration formed a key part of India’s enhanced climate
                  ambitions, alongside intermediate goals focused on renewable
                  energy expansion, emissions reduction, and long-term sustainable
                  development.
                </p>
              </div>
            </div>

            {/* TAMIL NADU */}
            <div className="col-lg-6 col-md-12" data-aos="slide-up" data-aos-delay="150">
              <div className="netzero-card">
                <div className="netzero-icon">
                  <MdLocationOn />
                </div>

                <h3>Tamil Nadu’s Net Zero Carbon Goal</h3>

                <p>
                  The Government of Tamil Nadu, under Chief Minister M.K. Stalin,
                  has set a clear target to achieve net zero carbon emissions by
                  2070, aligning with India’s national and global climate goals.
                </p>

                <p>
                  The state’s strategy emphasizes renewable energy growth,
                  nature-based carbon sequestration, and structured climate
                  planning to ensure a resilient and sustainable future.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>


      <FAQSection />
      <Footer />


    </>
  );
}
